export const partyObject = {
  fullName: "",
  contribution: null,
  monthlyMortgageContribution: null,
  share: null,
  other_config: { isWeb: true },
};
